const AdminType = {
  GET_ADMINS: 'GET_USERS',
  GET_ADMIN: 'GET_ADMIN',
  CREATE_ADMIN: 'CRAETE_ADMIN',
  UPDATE_ADMIN: 'UPDATE_USER',
  DELETE_ADMIN: 'DELETE_ADMIN',
  GET_OVERVIEW_REPORTS: 'GET_OVERVIEW_REPORTS',
}

export default AdminType
